
import React, { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { supabase } from "@/integrations/supabase/client";
import { Brand } from "@/types";
import { useLanguage } from "@/contexts/LanguageContext";
import { useIsMobile } from "@/hooks/use-mobile";


const Brands = () => {
  const { t } = useLanguage();
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    async function fetchBrands() {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from("brands")
          .select("*")
          .order("name");
        
        if (error) throw error;
        
        const typedData = data as Brand[];
        setBrands(typedData || []);
      } catch (error) {
        console.error(t('brands.loadingError'), error);
      } finally {
        setLoading(false);
      }
    }
    
    fetchBrands();
  }, []);

  // Se não tiver marcas e estiver carregando, não mostrar a seção
  if (brands.length === 0 && !loading) return null;
  
  const defaultLogo = "/lovable-uploads/noImage.jpeg";

  return (
    <section className="py-8 md:py-16 bg-brand-dark">
      <div className="container mx-auto px-4">
        <h2 className="section-heading text-white animate-slide-in-up text-2xl md:text-4xl">{t('brands.title')}</h2>
        <p className="section-subheading animate-slide-in-up animate-delay-100 text-sm md:text-base">{t('brands.subtitle')}</p>

        {loading ? (
          <div className="flex justify-center py-8">
            <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-brand-red"></div>
          </div>
        ) : (
          <Carousel
            className="my-6 md:my-8"
            opts={{
              align: "start",
              loop: true,
              dragFree: true,
            }}
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {brands.map((brand) => (
                <CarouselItem
                  key={brand.id}
                  className="basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5 xl:basis-1/6 pl-2 md:pl-4"
                >
                  <div className="bg-white rounded-lg p-3 md:p-4 h-24 md:h-32 flex items-center justify-center hover-scale shadow-md">
                    <img
                      src={brand.logo || defaultLogo}
                      alt={brand.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        )}
      </div>
    </section>
  );
};

export default Brands;
